const PROJECTS = [
  { name: "Kano Girls Education Initiative", org: "Yasmin Foundation", location: "Kano State", category: "Education", grant: "₦590,000,000", impact: "6,000 girls supported", status: "Completed", year: 2023, desc: "Provided school materials, uniforms, and teacher training for 8 underserved communities in Kano Municipal LGA.", initials: "YF" },
  { name: "Niger Delta Clean Water Project", org: "Wetlands Watch NGO", location: "Bayelsa State", category: "Health & Sanitation", grant: "₦350,000,000", impact: "1,200 residents with clean water", status: "Completed", year: 2024, desc: "Installation of solar-powered boreholes across riverine communities previously dependent on contaminated water sources.", initials: "WW" },
  { name: "Lagos Youth Skills Hub", org: "YouthForge Nigeria", location: "Lagos State", category: "Youth Empowerment", grant: "₦290,000,000", impact: "440 Youths", status: "Active", year: 2025, desc: "A vocational training center providing coding, graphic design, and entrepreneurship courses for unemployed youth aged 18–35.", initials: "YN" },
  { name: "Plateau Widow Cooperative", org: "Women Rising Collective", location: "Plateau State", category: "Poverty Alleviation", grant: "₦216,000,000", impact: "180 women", status: "Completed", year: 2025, desc: "Seed capital and business training for widow-led cooperatives engaged in food production and local trade.", initials: "WR" },
  { name: "Children Outreach", org: "Hope Bridge Initiative", location: "FCT", category: "Community Development", grant: "₦130,000,000", impact: "260 children off the streets", status: "Completed", year: 2024, desc: "A rehabilitation and education program for street-connected children in Wuse and Garki areas of the FCT.", initials: "HB" },
  { name: "Sokoto Climate Smart Farming", org: "Sahelian Farmers Alliance", location: "Sokoto State", category: "Agriculture", grant: "₦240,000,000", impact: "320 farmers", status: "Active", year: 2026, desc: "Distribution of drought-resistant seed varieties and training on climate-adaptive farming techniques.", initials: "SF" },
];

const OUTCOMES = [
  { value: "27", label: "Projects Funded" },
  { value: "36", label: "States Reached" },
  { value: "140,000+", label: "Lives Impacted" },
  { value: "₦4.5B+", label: "Total Distributed" },
];

export default function ImpactPage() {
  const totalGrants = PROJECTS.reduce((sum, p) => {
    const val = parseInt(p.grant.replace(/[₦,]/g, ""));
    return sum + val;
  }, 0);

  return (
    <>
      <style>{`
        .impact-hero { background:linear-gradient(160deg,#071428,#0B1F3A,#122844); padding:140px 5vw 80px; text-align:center; }
        .impact-hero h1 { font-family:'Playfair Display',serif; font-size:clamp(36px,6vw,68px); font-weight:900; color:white; margin-bottom:18px; }
        .outcomes-bar { background:#071428; padding:48px 5vw; }
        .outcomes-grid { display:grid; grid-template-columns:repeat(4,1fr); max-width:1000px; margin:0 auto; gap:2px; }
        .outcome-cell { text-align:center; padding:28px 16px; border-right:1px solid rgba(255,255,255,0.06); }
        .outcome-cell:last-child { border-right:none; }
        .outcome-val { font-family:'Playfair Display',serif; font-size:40px; font-weight:900; color:#E8B96A; }
        .outcome-label { font-size:12px; color:rgba(255,255,255,0.4); margin-top:6px; letter-spacing:1px; text-transform:uppercase; }
        .projects-grid { display:grid; grid-template-columns:repeat(3,1fr); gap:28px; max-width:1200px; margin:52px auto 0; }
        .project-card { border:1px solid var(--border-light); background:white; overflow:hidden; transition:all 0.3s; }
        .project-card:hover { transform:translateY(-4px); box-shadow:var(--shadow-md); }
        .project-header { padding:22px; background:linear-gradient(135deg,#0B1F3A,#1a3a5c); }
        .project-org-row { display:flex; align-items:center; gap:12px; margin-bottom:12px; }
        .project-avatar { width:38px; height:38px; border-radius:50%; background:rgba(201,150,62,0.2); display:flex; align-items:center; justify-content:center; font-size:12px; font-weight:700; color:#E8B96A; flex-shrink:0; }
        .project-name { font-family:'Playfair Display',serif; font-size:17px; font-weight:700; color:white; line-height:1.3; }
        .project-body { padding:22px; }
        .p-stat-label { font-size:10px; color:var(--text-muted); text-transform:uppercase; letter-spacing:0.5px; margin-bottom:2px; }
        .p-stat-val { font-size:13px; font-weight:700; color:var(--navy); }
        .p-stat-val.gold { color:#C9963E; }
        .total-bar { background:linear-gradient(135deg,#0B1F3A,#1a3a5c); padding:40px 5vw; text-align:center; }
        @media(max-width:1000px){ .projects-grid{grid-template-columns:repeat(2,1fr);} }
        @media(max-width:640px){ .projects-grid{grid-template-columns:1fr;} .outcomes-grid{grid-template-columns:repeat(2,1fr);} }
      `}</style>

      <section className="impact-hero">
        <span className="section-eyebrow" style={{ color: "#E8B96A" }}>Our Impact</span>
        <h1>Real Projects.<br /><em style={{ fontStyle: "italic", color: "#E8B96A" }}>Real Change.</em></h1>
        <p style={{ color: "rgba(255,255,255,0.6)", fontSize: 17, maxWidth: 540, margin: "16px auto 0", lineHeight: 1.75 }}>
          From classrooms in Kano to waterways in Bayelsa — here are the stories of change our members are funding.
        </p>
      </section>

      <div className="outcomes-bar">
        <div className="outcomes-grid">
          {OUTCOMES.map(o => (
            <div className="outcome-cell" key={o.label}>
              <div className="outcome-val">{o.value}</div>
              <div className="outcome-label">{o.label}</div>
            </div>
          ))}
        </div>
      </div>

      <section style={{ padding: "80px 5vw", background: "var(--off-white)" }}>
        <div style={{ textAlign: "center" }}>
          <span className="section-eyebrow">Featured Projects</span>
          <h2 className="section-title">Grant Recipients</h2>
        </div>
        <div className="projects-grid">
          {PROJECTS.map(p => (
            <div className="project-card" key={p.name}>
              <div className="project-header">
                <div className="project-org-row">
                  <div className="project-avatar">{p.initials}</div>
                  <div>
                    <div style={{ fontSize: 12, color: "rgba(255,255,255,0.6)" }}>{p.org}</div>
                    <div style={{ fontSize: 11, color: "rgba(255,255,255,0.4)", marginTop: 2 }}>{p.year}</div>
                  </div>
                  <span className={`badge badge-${p.status === "Active" ? "green" : "blue"}`} style={{ marginLeft: "auto", fontSize: 10 }}>
                    {p.status}
                  </span>
                </div>
                <div className="project-name">{p.name}</div>
              </div>
              <div className="project-body">
                <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 12 }}>
                  <span style={{ fontSize: 11, padding: "3px 8px", borderRadius: 2, fontWeight: 600, background: "rgba(201,150,62,0.1)", color: "#C9963E" }}>{p.category}</span>
                  <span style={{ fontSize: 11, padding: "3px 8px", borderRadius: 2, background: "rgba(11,31,58,0.06)", color: "var(--text-muted)" }}>📍 {p.location}</span>
                </div>
                <p style={{ fontSize: 13, color: "var(--text-muted)", lineHeight: 1.7, marginBottom: 16 }}>{p.desc}</p>
                <div style={{ display: "flex", justifyContent: "space-between", paddingTop: 14, borderTop: "1px solid var(--border-light)" }}>
                  <div>
                    <div className="p-stat-label">Grant Amount</div>
                    <div className="p-stat-val gold">{p.grant}</div>
                  </div>
                  <div style={{ textAlign: "right" }}>
                    <div className="p-stat-label">Community Impact</div>
                    <div className="p-stat-val">{p.impact}</div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* TOTAL */}
      <div className="total-bar">
        <div style={{ fontSize: 12, color: "#E8B96A", letterSpacing: 2, textTransform: "uppercase", marginBottom: 8 }}>Total Grants — Featured Projects</div>
        <div style={{ fontFamily: "'Playfair Display',serif", fontSize: 48, fontWeight: 900, color: "white" }}>
          ₦{totalGrants.toLocaleString()}
        </div>
        <div style={{ fontSize: 14, color: "rgba(255,255,255,0.45)", marginTop: 8 }}>Combined disbursement across 6 featured projects</div>
      </div>

      {/* TRANSPARENCY */}
      <section style={{ background: "#0B1F3A", padding: "64px 5vw", textAlign: "center" }}>
        <span className="section-eyebrow" style={{ color: "#E8B96A" }}>Financial Transparency</span>
        <h2 className="section-title light" style={{ maxWidth: 600, margin: "0 auto 16px" }}>Every Grant is Publicly Tracked</h2>
        <p style={{ color: "rgba(255,255,255,0.55)", fontSize: 16, maxWidth: 560, margin: "0 auto 32px", lineHeight: 1.75 }}>
          We publish quarterly impact reports and full financial statements. Members receive detailed disbursement logs directly in their dashboard.
        </p>
        <button className="btn-primary">Download 2025 Impact Report (PDF)</button>
      </section>
    </>
  );
}
